import SamaritanFetch from './httpClient';

export const fetchNewsfeed = (userId: number) =>
    SamaritanFetch.v2(`/users/${userId}/newsfeed`);
